export const API_KEY = 'AIzaSyBwCvDt-pz9Ak4e1SDIl919v9bzPGTQYNg'

// export default API_KEY